export default "__VITE_ASSET__0cc059a8__"